export const isValidDateObject = (obj) => {
    return obj instanceof Date && !isNaN(obj);
}